import publicApi from './publicApi';

class PublicPriceService {
  constructor() {
    this.cache = new Map();
    this.cacheTTL = 60 * 1000; // 60 seconds - match server update frequency
    this.lastFetchTime = null;
  }

  async fetchPrices(symbols, caller = 'unknown') {
    if (!symbols || symbols.length === 0) return {};
    
    // Log the request
    console.log(`[PublicPriceService] Request from ${caller}: ${symbols.length} symbols:`, symbols);
    
    const cacheKey = symbols.sort().join(',');
    const cached = this.cache.get(cacheKey);
    
    if (cached && Date.now() - cached.timestamp < this.cacheTTL) {
      console.log(`[PublicPriceService] Cache hit for ${caller}: ${Object.keys(cached.data).length} coins (${Math.floor((Date.now() - cached.timestamp) / 1000)}s old)`);
      return cached.data;
    }

    try {
      console.log(`[PublicPriceService] Fetching prices from public API for ${caller}: ${symbols.length} symbols...`);
      
      // Get prices from public endpoint
      const symbolsParam = symbols.join(',');
      const response = await publicApi.get(`/api/public/prices?symbols=${symbolsParam}`);
      const prices = response.data;
      
      console.log(`[PublicPriceService] Public API returned prices for ${Object.keys(prices).length} symbols`);
      
      // Cache the result
      this.cache.set(cacheKey, {
        data: prices,
        timestamp: Date.now()
      });
      
      this.lastFetchTime = Date.now();
      
      console.log(`[PublicPriceService] Successfully fetched prices for ${Object.keys(prices).length} symbols from ${caller}`);
      return prices;
      
    } catch (err) {
      console.error(`[PublicPriceService] Error fetching prices from ${caller}:`, err);
      throw err;
    }
  }

  getLastFetchTime() {
    return this.lastFetchTime;
  }

  async getFreshnessSummary(symbols) {
    // For public API, we don't have detailed freshness info
    // Return a simple summary
    return {
      total_symbols: symbols.length,
      fresh_count: symbols.length,
      stale_count: 0,
      missing_count: 0,
      overall_status: 'fresh'
    };
  }

  clearCache() {
    this.cache.clear();
    console.log('[PublicPriceService] Cache cleared');
  }
}

// Create a singleton instance
const publicPriceService = new PublicPriceService();

export default publicPriceService;